import { faGrid } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, PlainTooltip } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { useDensity } from './useDensity';

const HIGH_DENSITY = -2;

export type IDensitySwitchProps = IContainerProps;

export const DensitySwitch: React.FC<IDensitySwitchProps> = (props) => {
  const { sx } = props;
  const { t } = useTranslation();
  const [density, setDensity] = useDensity();
  const isNormalDensity = density === 0;

  return (
    <PlainTooltip
      supportingText={
        isNormalDensity
          ? t('DensitySwitch.supportingText.enable')
          : t('DensitySwitch.supportingText.disable')
      }
    >
      <IconButton
        sx={sx}
        variant="outlined"
        icon={<FontAwesomeIcon icon={faGrid} />}
        selected={!isNormalDensity}
        toggle
        onClick={() => setDensity(isNormalDensity ? HIGH_DENSITY : 0)}
      />
    </PlainTooltip>
  );
};
